import {useRealtimeChannel} from "@/api/realtime/RealtimeChannelHooks.ts";
import {DungeonSettings} from "@/encounter/model/DungeonSettings.ts";

export function useDungeonSettingsRealtime(encounterId: string) {
    const {subscribe} = useRealtimeChannel<DungeonSettings>(`/encounters/${encounterId}/dungeonSettings`);
    return subscribe;
}
